import SportTeamsListBlock from './SportTeamsListBlock';
import { SportTeamsListBlockProps, SportTeamsListBlockValueProps } from './types';

export type { SportTeamsListBlockProps, SportTeamsListBlockValueProps };
export default SportTeamsListBlock;
